import React from "react";
import {
  InstantSearch,
  Hits,
  Configure,
  connectStateResults
} from "react-instantsearch-dom";
import { makeStyles } from "@material-ui/styles";
import algoliasearch from "algoliasearch/lite";
import Input from "./input";
import Pagination from "./pagination";
import * as hitComps from "./hitComps";
import PoweredBy from "./poweredBy";

const Results = connectStateResults(
  ({ searchState: state, searchResults: res, children }) =>
    res && res.nbHits > 0 ? children : `Inga resultat för '${state.query}'`
);

const Stats = connectStateResults(
  ({ searchResults: res }) => res && res.nbHits > 0 && `${res.nbHits} resultat`
);

const useStyles = makeStyles(theme => ({
  searchContainer: { paddingTop: "16px", minHeight: "500px" },
  hits: {
    padding: "8px",
    "& h3": { margin: 0 },
    "& h4": { margin: `${0}!important` },
    "& .ais-Hits": {},
    "& ul": {
      listStyleType: "none",
      margin: 0,
      padding: 0
    },
    "& li": {
      padding: "16px",
      borderBottom: `1px solid ${theme.palette.divider}`,
      transition: theme.transitions.create(["background-color"], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shortest
      }),
      "&:nth-child(even)": {
        backgroundColor: theme.app.tableHighlight
      }
    },
    "& a": {
      color: "inherit",
      textDecoration: "none"
    },
    "& p.hit__type": {
      fontSize: "0.75rem",
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      margin: "0 0 8px!important"
    }
  },
  algolia: { marginTop: "16px" }
}));

export default function Search({ indices }) {
  const classes = useStyles();
  const searchClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );
  return (
    <div className={classes.searchContainer}>
      <InstantSearch searchClient={searchClient} indexName={indices[0].name}>
        <Input />
        <div className={classes.hits}>
          {indices.map(({ name, hitComp }) => (
            <Results key={name}>
              <Stats />
              <Hits hitComponent={hitComps[hitComp]()} />
            </Results>
          ))}
        </div>
        <Configure hitsPerPage={5} />
        <Pagination />
        <div className={classes.algolia}>
          <PoweredBy />
        </div>
      </InstantSearch>
    </div>
  );
}
